import { render, staticRenderFns } from "./EventSuppliers.vue?vue&type=template&id=57de031c&scoped=true"
import script from "./EventSuppliers.vue?vue&type=script&lang=js"
export * from "./EventSuppliers.vue?vue&type=script&lang=js"
import style0 from "./EventSuppliers.vue?vue&type=style&index=0&id=57de031c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57de031c",
  null
  
)

export default component.exports